import { render, staticRenderFns } from "./EmployeeUserPicker.vue?vue&type=template&id=88f45b8a&"
import script from "./EmployeeUserPicker.vue?vue&type=script&lang=ts&"
export * from "./EmployeeUserPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports